;(function() {
  'use strict'

  angular.module('app.survey').component('surveyNextInline', {
    templateUrl: 'survey-next-inline.html',
    bindings: {
      action: '&',
      onNext: '&',
    },
  })
})()
